module.exports = __webpack_public_path__ + "img/how.e850ffd8.png";